/*
 * InspiredGrabs™ — Globo Filter Auto-Collapse
 *
 * Purpose:
 * - Auto-collapse Collection after a radio selection.
 * - Auto-collapse Type after a radio selection.
 *
 * Intentionally untouched:
 * - Subcategory
 * - Color
 * - Material
 * - Size
 * - Price Range
 *
 * Uses Globo's own filter-heading button to collapse the filter.
 * Does not modify Globo app/library files.
 */

(function () {
  'use strict';

  var AUTO_COLLAPSE_FILTERS = ['Collection', 'Type'];

  function getFilterBlock(element) {
    return element.closest('.gf-option-block');
  }

  function getFilterTrigger(block) {
    if (!block) return null;

    return block.querySelector(
      '.gf-block-title .h3[role="button"][aria-expanded]'
    );
  }

  function getFilterName(trigger) {
    if (!trigger) return '';

    var label = trigger.querySelector(':scope > span:first-child');

    return label ? label.textContent.trim() : '';
  }

  function shouldAutoCollapse(trigger) {
    return AUTO_COLLAPSE_FILTERS.indexOf(getFilterName(trigger)) !== -1;
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('button[role="radio"][data-fvalue]');

    if (!option) return;

    var block = getFilterBlock(option);
    var trigger = getFilterTrigger(block);

    if (!trigger || !shouldAutoCollapse(trigger)) return;

    /*
     * Let Globo finish processing the radio selection first.
     * Then use Globo's existing heading control to collapse
     * only if that filter is still expanded.
     */
    window.setTimeout(function () {
      if (
        document.documentElement.contains(trigger) &&
        trigger.getAttribute('aria-expanded') === 'true'
      ) {
        trigger.click();
      }
    }, 0);
  });
})();